module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/6f7573b588c11026afe1d5798a4242a2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/download-icon.svg
// module id = vGvd
// module chunks = 1